import React, {Fragment} from 'react';

function TagListItem(props) {

    return (

        <button type="button" className="btn btn-primary btn-sm">{props.name}</button>


    )
}

export default TagListItem;


// WEBPACK FOOTER //
// ./src/components/TagListItem/TagListItem.jsx